export default async () => {
  const isWebView = process.env.WEBVIEW === '1'
  const platform = process.env.PLATFORM
  const allowHostname = ['olymp-kz.xyz', 'olymp15.casino']

  if ('serviceWorker' in navigator) {
    if (!isWebView && platform === 'olymp' && allowHostname.includes(location.hostname)) {
      navigator.serviceWorker
        .register('/ol-sw-mrr.js')
        .then((registration) => {
          // console.log('Service Worker зарегистрирован:', registration)

          // Проверяем наличие новой версии
          registration.onupdatefound = () => {
            const newWorker = registration.installing
            if (newWorker) {
              // console.log('Найден новый Service Worker:', newWorker)

              newWorker.onstatechange = () => {
                if (newWorker.state === 'installed') {
                  if (navigator.serviceWorker.controller) {
                    // console.log('Новая версия Service Worker готова.')

                    if (registration.waiting) {
                      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
                      // console.log('Отправлена команда SKIP_WAITING для нового Service Worker')
                    }
                  } else {
                    // console.log('Service Worker установлен впервые.')
                  }
                }
              }
            }
          }
        })
        .catch((error) => {
          console.error('Ошибка регистрации Service Worker:', error)
        })

      // Следим за изменением контроллера (новая версия SW)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // console.log('Service Worker обновился, можно перезагрузить страницу!')
        // location.reload()
      })
    }

    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        if (registration.active && registration.active.scriptURL.endsWith('/service-worker.js')) {
          registration.unregister()
        }
      })
    })
  }
}
